/*
 * @providesModule SignInMessage
 */

import React from 'react';
import {View, Text, TouchableOpacity, StyleSheet} from 'react-native';
import {_m} from 'INTL';
import styles from 'SMSVerifyStyle';
import SkillzStyle from 'SkillzStyle';

type SignInMessageProps = {
  signInPress: () => void;
  isNewUI?: boolean;
};

const SignInMessage = ({signInPress, isNewUI}: SignInMessageProps) => {
  return (
    <View style={styles.dataFee}>
      <Text allowFontScaling={false} style={isNewUI ? style().newUIsignInText : styles.signInText}>
        {_m('Already have an account?') + ' '}
      </Text>
      <TouchableOpacity onPress={signInPress}>
        <Text allowFontScaling={false} style={styles.signInBtn}>
          {_m('Sign In')}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

export default SignInMessage;

const style = () => {
  const {textColorPrimary} = SkillzStyle.getOverriddenFallbackTheme();

  return StyleSheet.create({
    newUIsignInText: {
      color: textColorPrimary.color,
      fontFamily: 'Open Sans',
    },
  });
};
